
import { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductsSection = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { id: 'all', name: 'الكل' },
    { id: 'cameras', name: 'كاميرات المراقبة' },
    { id: 'access', name: 'أنظمة التحكم' },
    { id: 'gates', name: 'البوابات' },
    { id: 'alarm', name: 'الإنذار' },
  ];

  const products = [
    {
      id: 1,
      category: 'cameras',
      name: 'كاميرا مراقبة 4K',
      description: 'دقة عالية مع رؤية ليلية متقدمة',
      image: 'https://public.readdy.ai/ai/img_res/24fdfaf53018dd7c930b53358b7a49a3.jpg',
      badge: 'الأكثر مبيعاً',
    },
    {
      id: 2,
      category: 'access',
      name: 'نظام بصمة الوجه',
      description: 'تقنية التعرف على الوجه بدقة عالية',
      image: 'https://readdy.ai/api/search-image?query=modern%20facial%20recognition%20access%20control%20system%2C%20sleek%20touchscreen%20biometric%20device%2C%20professional%20security%20terminal%20with%20face%20scanner%2C%20contemporary%20design%2C%20mounted%20on%20clean%20white%20wall%2C%20high-tech%20access%20control%20panel%2C%20corporate%20security%20equipment%2C%20product%20photography&width=600&height=800&seq=product-face-recognition-002&orientation=portrait',
      badge: 'جديد',
    },
    {
      id: 3,
      category: 'gates',
      name: 'بوابة أمنية ذكية',
      description: 'بوابة إلكترونية بتحكم كامل',
      image: 'https://readdy.ai/api/search-image?query=modern%20automatic%20security%20gate%20barrier%2C%20sleek%20electronic%20access%20control%20barrier%20arm%2C%20professional%20parking%20gate%20system%2C%20contemporary%20design%20with%20LED%20lights%2C%20commercial%20security%20barrier%2C%20clean%20industrial%20look%2C%20high-quality%20security%20equipment%2C%20architectural%20photography%20style&width=600&height=650&seq=product-smart-gate-003&orientation=portrait',
      badge: '',
    },
    {
      id: 4,
      category: 'alarm',
      name: 'نظام إنذار الحريق',
      description: 'كشف مبكر وإنذار فوري',
      image: 'https://readdy.ai/api/search-image?query=professional%20fire%20alarm%20control%20panel%2C%20modern%20fire%20detection%20system%2C%20red%20emergency%20alert%20device%2C%20high-tech%20fire%20safety%20equipment%2C%20wall-mounted%20alarm%20system%2C%20clean%20corporate%20design%2C%20security%20control%20panel%2C%20product%20photography%20with%20dramatic%20lighting&width=600&height=750&seq=product-fire-alarm-004&orientation=portrait',
      badge: '',
    },
    {
      id: 5,
      category: 'cameras',
      name: 'كاميرا PTZ متحركة',
      description: 'تحكم كامل بزاوية 360 درجة',
      image: 'https://readdy.ai/api/search-image?query=professional%20PTZ%20security%20camera%2C%20motorized%20pan-tilt-zoom%20surveillance%20camera%2C%20white%20dome%20camera%20with%20sleek%20design%2C%20high-tech%20rotating%20CCTV%20camera%2C%20premium%20security%20equipment%2C%20product%20photography%20on%20clean%20background%2C%20commercial%20grade%20surveillance%20device&width=600&height=700&seq=product-ptz-camera-005&orientation=portrait',
      badge: '',
    },
    {
      id: 6,
      category: 'access',
      name: 'قارئ البطاقات الذكية',
      description: 'نظام بطاقات RFID متطور',
      image: 'https://readdy.ai/api/search-image?query=modern%20RFID%20card%20reader%2C%20sleek%20access%20control%20keypad%2C%20professional%20smart%20card%20scanner%2C%20contemporary%20security%20terminal%2C%20wall-mounted%20access%20device%2C%20clean%20minimalist%20design%2C%20high-tech%20entry%20system%2C%20product%20photography%20with%20soft%20lighting&width=600&height=800&seq=product-card-reader-006&orientation=portrait',
      badge: '',
    },
  ];

  const filteredProducts = activeFilter === 'all'
    ? products
    : products.filter(product => product.category === activeFilter);

  return (
    <section className="py-24 bg-white" data-product-shop>
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary bg-primary/5 mb-6">
            <span className="text-sm font-semibold text-primary">منتجاتنا</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-navy-light mb-6">
            أحدث الأنظمة الأمنية
          </h2>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeFilter === filter.id
                  ? 'bg-primary text-white shadow-lg'
                  : 'bg-transparent text-gray-dark border border-silver/50 hover:border-primary hover:text-primary'
              }`}
            >
              {filter.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-silver/30 cursor-pointer"
            >
              {/* Image Container */}
              <div className="relative h-[350px] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-all duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>

                {/* Badge */}
                {product.badge && (
                  <div className="absolute top-4 right-4 px-4 py-2 bg-primary text-white text-xs font-semibold rounded-full">
                    {product.badge}
                  </div>
                )}

                {/* Hover Button */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <Link
                    to="/products"
                    className="px-6 py-3 bg-white text-navy font-semibold rounded-lg hover:bg-primary hover:text-white transition-all duration-300 whitespace-nowrap"
                  >
                    عرض التفاصيل
                  </Link>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-navy-light mb-2 group-hover:text-primary transition-all duration-300">
                  {product.name}
                </h3>
                <p className="text-gray-dark text-sm leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white text-base font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            <span>عرض جميع المنتجات</span>
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
